export default __webpack_public_path__ + "static/media/header-bg-kalendar-4.f7c3e38d.jpg";